import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Item } from 'src/app/models/item.model';
import { RequestUpdatePayload } from 'src/app/components/job-details/request-update/model/request-update-payload.model';
import { UserContactInfo } from 'src/app/models/user-contact-info.model';
import { ApiMethod } from 'src/app/decorators/api-method.decorator';

@Injectable({
	providedIn: 'root'
})
export class RequestUpdateService {

	private baseJobUrl = `${environment.baseUrl}/job`;

	constructor(private httpClient: HttpClient) { }

	@ApiMethod()
	requestUpdate(token: string, payload: RequestUpdatePayload): Observable<void> {
		return this.httpClient.post<void>(`${this.baseJobUrl}/${token}/request-update`, payload);
	}

	@ApiMethod()
	getRequestUpdateCustomers(token: string): Observable<UserContactInfo[]> {
		return this.httpClient.get<UserContactInfo[]>(`${this.baseJobUrl}/${token}/lookup/relevant-customers`);
	}

	@ApiMethod()
	getLastRequestUpdateChoiceForStaffMembers(token: string): Observable<Item<number, number>[]> {
		return this.httpClient.get<Item<number, number>[]>(`${this.baseJobUrl}/${token}/request-update/past-notification-types`);
	}
}
